module.exports = __webpack_public_path__ + "img/artistes.7b9fd50e.jpg";